import { AsLeftResultM31Formula } from './M31.formula';
import { paddingLabel } from '../../../HMISection/Data/C11/C11.data';
import { labelWidth } from '../../../HMISection/Data/P710/P710.data';
import { Result } from 'journeys/portal/Forms/Sections.constants';

export const AsLeftTestTableSectionDataM31 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'AsleftTest',
                label: 'As-Left Test',
                isLabel: true,
                xs: 12,
                fontWeight: '700',
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F406AltMacWasActivatedInFieldLabel',
                    label: 'MAC was activated in field?',
                    xs: 4,
                    labelWidth: '100%',
                    padding: '0 0 0 8px',
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F406AltMacWasActivatedInField',
                    value: formData.F102AftResult !== 'PASS' ? formData.F406AltMacWasActivatedInField : '',
                    isRequired: formData.F102AftResult !== 'PASS',
                    isDisabled: formData.F102AftResult === 'PASS',
                    isDropdown: formData.F102AftResult !== 'PASS',
                    readOnly: formData.F102AftResult === 'PASS',
                    placeholder: 'Select YES or NO',
                    options: [{ name: 'Select YES or NO', value: '' },
                    { name: 'YES', value: 'YES' },
                    { name: 'NO', value: 'NO' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    height: '1.5rem',
                }
            ]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F378AltHmistatus1Label',
                    label: 'HMI Status',
                    xs: 4,
                    labelWidth: '100%',
                    padding: '0 0 0 8px',
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F378AltHmistatus1',
                    isDropdown: formData.F102AftResult !== 'PASS',
                    value: formData.F102AftResult !== 'PASS' ? formData.F378AltHmistatus1 : '',
                    isRequired: formData.F102AftResult !== 'PASS',
                    isDisabled: formData.F102AftResult === 'PASS',
                    placeholder: 'Select HMI Status',
                    options: [{ name: 'Select HMI Status', value: '' },
                    { name: 'NORMAL', value: 'NORMAL' },
                    { name: 'ALARM', value: 'ALARM' },
                    { name: 'FAULT', value: 'FAULT' }],
                    labelWidth: '0%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    marginBottom: '4px',
                    readOnly: formData.F102AftResult === 'PASS',
                    height: formData.F102AftResult !== 'PASS' ? '1.5rem' : '1.25rem',
                    width: '100%',
                },
                {
                    key: 'F103AltResultLabel',
                    label: Result.AS_LEFT_RESULT_LABEL,
                    xs: 4,
                    isLabel: true,
                    fontWeight: '700',
                    labelWidth,
                    fontSize: '9pt',
                    textAlign: 'right',
                    padding: paddingLabel,
                },
                {
                    key: 'F103AltResult',
                    value: formData.F102AftResult !== 'PASS' ? AsLeftResultM31Formula(formData) : '',
                    isDisabled: formData.F102AftResult === 'PASS',
                    width: '100%',
                    readOnly: true,
                    labelWidth: '0',
                    isCalculatedNew: true,
                    xs: 2,
                    textAlign: 'center',
                    height: '1.25rem',
                    borderRight: '0',
                    borderBottom: '0',
                    direction: 'rtl',
                    marginBottom: '4px',
                    inputMarginRight: '4px',
                    isLabelBold: true,
                    fontWeight: '700',
                }
            ]
        },
    ]
});
